/*=========================================================================================
  File Name: getters.js
  namespace: labs
  Description: Vuex Store - Lab getters
==========================================================================================*/
import { buildLabState } from './state'
import { getYearsUpTo } from '@/utils/utils'

const getters = {
  getCurrentLab: (state) => {
    return state.currentLab
  },
  getObjectives: ({ objectives }) => objectives,
  getNewLab: () => {
    return buildLabState()
  },
  getLabList: (state) => {
    return {
      results: state.results,
      count: state.count,
    }
  },
  getLabEntries: (state) => {
    return state.labList
  },
  getLabStatusList: (state) => {
    return state.LAB_POSSIBLE_STATUS
  },
  getLabAllStatus: (state) => {
    return Object.entries(state.LAB_POSSIBLE_STATUS).map(([, value]) => ({
      label:
        value.charAt(0).toUpperCase() +
        value.slice(1).toLowerCase().replace(/_/g, ' '),
      value: value,
    }))
  },
  getLabDifficulties: (state) => {
    return Object.entries(state.LAB_POSSIBLE_DIFFICULTY).map(([, value]) => {
      return {
        label: value.charAt(0).toUpperCase() + value.slice(1).toLowerCase(),
        value: value,
      }
    })
  },
  getLabsCategories(state) {
    return Object.entries(state.categoryList).map(([key, value]) => {
      return {
        label: value.name.charAt(0).toUpperCase() + value.name.slice(1),
        value: key,
      }
    })
  },
  getLabsCategoriesEntries(state) {
    return state.categoryList
  },
  labTypeOptions() {
    return [
      { value: 'github', label: 'GitHub' },
      { value: 'azure', label: 'Azure' },
      { value: 'els', label: 'ELS' },
      { value: 'pta', label: 'PTA' },
    ]
  },
  labSeverityOptions() {
    return [
      { value: 'low', label: 'Low' },
      { value: 'medium', label: 'Medium' },
      { value: 'high', label: 'High' },
      { value: 'critical', label: 'Critical' },
    ]
  },
  labYearOptions() {
    const startListFrom = 2005
    return getYearsUpTo(startListFrom)
  },
}

export default getters
